import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@material-ui/core/styles";

import { SelectChangeEvent } from "@mui/material/Select";
import { TextField } from "@mui/material";

interface BasicSelectProps {
  title: string;
  menuItems: { value: number | string; label: string }[];
  onChange: (event: SelectChangeEvent<unknown>) => void;
  selectedValue?: number | string;
}

const useStyles = makeStyles({
  select: {
    width: "321px",
    height: "35px",
    borderRadius: "20px",
    backgroundColor: "#F2F2F2",
    "&:hover": {
      backgroundColor: "#00B49D",
      color: "#fff", // This changes the text color of the Select, but not the label
      "& + .MuiInputLabel-root": {
        // Targeting the label that comes after the hovered Select
        color: "#fff", // Change label text color to white on hover
      },
      transition: "0.3s",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
  },
});

export default function BasicSelect({ 
  title,
  menuItems,
  onChange,
  selectedValue,
}: BasicSelectProps) {
  const classes = useStyles();
  return (
    <Box>
      <FormControl
        fullWidth
        sx={{
          p: 2.5,
          textAlign: "left",
        }}
      >
        <InputLabel
          id="demo-simple-select-autowidth-label"
          sx={{ paddingLeft: 3 }}
        >
          {title}
        </InputLabel>
        <Select
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select"
          className={classes.select}
          label={title}
          onChange={onChange}
          value={selectedValue}
        >
          {menuItems.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
